/**
 * Envoie une exception client à `/api/client-error` pour qu'elle soit tracée
 * côté serveur (logs Vercel). Best-effort, ne throw jamais : on ne veut pas
 * aggraver une page déjà en erreur.
 */
export function reportClientError(
  error: Error & { digest?: string },
  scope: "page" | "global",
): void {
  try {
    const payload = JSON.stringify({
      message: error?.message ?? String(error),
      stack: error?.stack ?? null,
      digest: error?.digest ?? null,
      scope,
      url: typeof window !== "undefined" ? window.location.href : null,
    });
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon("/api/client-error", payload);
      return;
    }
    void fetch("/api/client-error", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // best-effort
  }
}
